import UserWelcomeCard from '../../components/user-welcome-card/user-welcome-card.component';
import { TrilhaCard } from '../../components/TrilhaCard/trilha-card.component';
import useCursos from './use-cursos.hook';
import SidebarAndContainer from '../../components/sidebar-and-container/sidebar-and-container.component';
import Title from '../../components/title/title.component';
import './cursos.styles.scss';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export const HomeCursos = () => {
  const { destaques } = useCursos();
  const { t } = useTranslation('trilhas');

  return (
    <>
      <SidebarAndContainer cursos={true}>
        <UserWelcomeCard />

        <div className="cursos-wrapper__cursos-title-button">
          <Title title="Trilhas" />

          <Link to="/cursos/all" className="button-line">
            {t('trilhas:seeAllCourses')}
          </Link>
        </div>

        <div className="cursos-wrapper__cursos-cards-wrapper ">
          {destaques?.map((trilha) => (
              <TrilhaCard t={t} key={trilha.id} trilha={trilha} />
            ))}
        </div>
      </SidebarAndContainer>
    </>
  );
};
